import { IAppState } from '../../redux';
import { ICoordinates } from '../../redux/reducers';

const MOSCOW_CENTER_COORIDINATES: ICoordinates = {
  lat: 55.755864,
  lng: 37.621255,
};

export function selectOfferCoordinatesWithFallback(state: IAppState): ICoordinates {
  const { offer, user } = state;

  const offerCoordiantes = offer.geo?.coordinates;
  const userCoordiantes = user.geo ? { lat: user.geo.lat, lng: user.geo.lng } : null;

  return offerCoordiantes || userCoordiantes || MOSCOW_CENTER_COORIDINATES;
}
